import { useSyncExternalStore } from 'react';
import { ConsentInput } from '../types';
import { shallowEqualConsent } from '../utils';
let currentConsent: ConsentInput | null = null;
const consentListeners = new Set<() => void>();
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const gtmListeners = new Set<(any: any) => void>();

// Global hook
if (typeof window !== 'undefined') {
  window.setGtmConsentListener = (cb: () => void) => {
    gtmListeners.add(cb);
  };
  window.onConsentChangeFromGTM = updateConsentListeners;
}
function getSnapshotFromGtm(): ConsentInput | null {
  if (typeof window?.getGtmPermissions === 'function') {
    const result = window.getGtmPermissions();
    return result;
  }
  return null;
}
function getSnapshot(): ConsentInput | null {
  return currentConsent;
}

// Updates the consent state in GTM
function updateGtmConsent(consent: ConsentInput): void {
  if (shallowEqualConsent(consent, currentConsent)) return;
  gtmListeners.forEach(cb => cb(consent));
}
function updateConsentListeners() {
  const result = getSnapshotFromGtm();
  if (result && !shallowEqualConsent(result, currentConsent)) {
    currentConsent = result;
  }
  consentListeners.forEach(cb => cb());
}

// Subscribe to changes in the consent state
function subscribe(callback: () => void) {
  consentListeners.add(callback);
  return () => consentListeners.delete(callback);
}

// Hook export
export function useGtmConsentStore(): {
  consent: ConsentInput | null;
  updateGtmConsent: (consent: ConsentInput) => void;
  getSnapshotFromGtm: () => ConsentInput | null;
} {
  const consent = useSyncExternalStore(subscribe, getSnapshot, () => null);
  return {
    consent,
    updateGtmConsent,
    getSnapshotFromGtm
  };
}